module.exports = __webpack_public_path__ + "static/collage-b62e09bcb6d188064442e524f712143c.svg";